export default __webpack_public_path__ + "static/media/plodeIconSvg.3bc1a774.svg";